import type { Location } from 'react-router-dom'

const EXPLORER_LAYOUT_PREFIXES = [
  '/explorer',
  '/brief',
  '/selection',
  '/shortlists',
  '/inboxes',
  '/discover',
]

/**
 * Whether a pathname renders the explorer layout, i.e. the pane stack is still
 * on screen - either as the page itself or underneath one of its modals.
 * Anything else is a page that replaces the explorer.
 */
export const isExplorerLayoutPath = (pathname: string): boolean =>
  pathname === '/' ||
  EXPLORER_LAYOUT_PREFIXES.some(prefix => pathname.startsWith(prefix))

/**
 * Returns the appropriate base route for shortlist navigation
 * @param location - The current location object
 * @returns '/search' if in search context, empty string otherwise
 */
export const getShortlistBaseRoute = (location?: Location): string => {
  return location?.pathname?.startsWith('/search') ? '/search' : ''
}

/**
 * Returns the root return path for a given pathname.
 * Used by selection modals to redirect back to the originating page.
 */
export const getSelectionReturnPath = (pathname: string): string => {
  return pathname.startsWith('/search/') ? '/search' : '/'
}

/**
 * Returns the selection route base for a given pathname.
 * e.g. '/search/selection' when in search context, '/selection' otherwise.
 */
export const getSelectionBase = (pathname: string): string => {
  return pathname.startsWith('/search/') ? '/search/selection' : '/selection'
}
